import Ts from "@/components/search/parser/Terminals"

if (!Array.prototype.flatMap) {
  Array.prototype.flatMap = function(f) {
    return this.reduce((acc, x) => acc.concat(f(x)), [])
  }
}

class Rule {
  constructor(name) {
    this.name = name
  }

  expand() {
    return [Grammar[this.name]]
  }
}

class Or {
  constructor(...choices) {
    this.choices = choices.map(c => c instanceof Array ? c : [c])
  }

  expand() {
    return this.choices
  }
}

class Optional {
  constructor(choice) {
    this.choice = choice instanceof Array ? choice : [choice]
  }

  expand() {
    return [[], this.choice]
  }
}

class OptionalOr {
  constructor(...choices) {
    this.choices = choices.map(c => c instanceof Array ? c : [c])
  }

  expand() {
    return this.choices.concat([[]])
  }
}

class Conjunct {
  constructor(...items) {
    if (!items.length) throw Error("Wrong Grammar")
    this.items = items.map(c => c instanceof Array ? c : [c])
  }

  expand() {
    const first = this.items[0]
    const rest = this.items.slice(1)
    if (!rest.length) return [first]
    return [
      first.concat([new OptionalConjunct(...rest)]),
      [new Conjunct(...rest)]
    ]
  }
}

class OptionalConjunct {
  constructor(...items) {
    if (!items.length) throw Error("Wrong Grammar")
    this.items = items.map(c => c instanceof Array ? c : [c])
  }

  expand() {
    const first = this.items[0]
    const rest = this.items.slice(1)
    if (!rest.length) return [first, []]
    return [
      first.concat([new OptionalConjunct(rest)]),
      [new OptionalConjunct(rest)]
    ]
  }
}
      

export const Grammar = {
  "S": [
    Ts.show_films,
    new Or([Ts.that_are, new Rule("FilterList")], []),
  ],
  "FilterList": [
    new Optional(Ts.not),
    new Rule("Filter"),
    new Or(
      [new Or(Ts.that_are, Ts.and, Ts.or), new Rule("FilterList")],
      []
    )
  ],
  "Filter": [
    new Or(
      // Date
      [Ts.made, new Or(Ts.in, Ts.after, Ts.before), Ts.year],
      // Director
      [Ts.directed_by, Ts.person],
      // Writer
      [Ts.written_by, Ts.person],
      // Actor
      [Ts.starring, Ts.person],
      // Rated
      [
        Ts.rated,
        new Conjunct(
          [Ts.rating, new OptionalOr(Ts.plus, Ts.minus)],
          [Ts.by, Ts.user]
        ),
      ],
      // Tagged
      [
        Ts.tagged,
        new Conjunct([Ts.as, Ts.tag], [Ts.under, Ts.cat]),
      ],
      // Owned
      [Ts.owned, Ts.by, Ts.user],
    )
  ],
}

// In: [Part]
// Out: [[Part]]
export const simplify = choice => {
  if (choice.length === 0
      || choice[0].type == "keyword"
      || choice[0].type == "value")
    return [choice]
  const part = choice[0]
  const rest = choice.slice(1)
  return part
    .expand()
    .flatMap(c => simplify(c))
    .flatMap(g => g.length ? [g.concat(rest)] : simplify(rest))
}

export default {
  Grammar,
  simplify
}
